/** Response of the `email-provider-detect` edge function. */
export interface EmailProviderDetection {
  suggestedProvider: "google" | "microsoft" | null;
  confidence: "high" | "medium" | "unknown";
  reason:
    | "known_consumer_domain"
    | "google_mx"
    | "microsoft_mx"
    | "ambiguous_mx"
    | "unrecognized_mx"
    | "no_mx"
    | "dns_error"
    | "invalid_email";
}

export const EMAIL_SENDERS_HELP_PATH = "/help/settings/managing-email-senders";

/** Plain-language verdict. Copy follows the help article "Is My Email Google or Outlook?". */
export function describeDetection(d: EmailProviderDetection): { title: string; body: string } {
  const consumer = d.reason === "known_consumer_domain";
  if (d.suggestedProvider === "google") {
    return {
      title: consumer
        ? "This is a Google (Gmail) address"
        : `${d.confidence === "high" ? "Looks like" : "Probably"} Google (Google Workspace)`,
      body: "Use Connect Gmail.",
    };
  }
  if (d.suggestedProvider === "microsoft") {
    return {
      title: consumer
        ? "This is a Microsoft (Outlook.com) address"
        : `${d.confidence === "high" ? "Looks like" : "Probably"} Microsoft (Microsoft 365)`,
      body: "Use Connect Outlook.",
    };
  }
  if (d.reason === "invalid_email") {
    return {
      title: "That doesn't look like an email address",
      body: "Enter your full address, for example you@yourcompany.com.",
    };
  }
  if (consumer) {
    return {
      title: "This is a different email provider",
      body: "Built It connects Google and Microsoft accounts only, so this address (for example Yahoo, iCloud, or AOL) can't be connected as a sender.",
    };
  }
  return {
    title: "We couldn't tell",
    body: "Choose the one you sign in to on the web: gmail.com means Google (Connect Gmail); outlook.com or office.com means Microsoft (Connect Outlook).",
  };
}
